(function () {
  function track(eventName, params) {
    if (typeof window.fbq !== 'function') return;
    window.fbq('track', eventName, params || {});
  }

  function moneyValue(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return 0;
    return value / 100;
  }

  function trackViewContent() {
    var cfg = window.pathrohiMetaPixel;
    if (!cfg || !cfg.product) return;

    track('ViewContent', {
      content_ids: [String(cfg.product.variantId)],
      content_name: cfg.product.title,
      content_type: 'product',
      value: moneyValue(cfg.product.price),
      currency: cfg.currency,
    });
  }

  function trackAddToCartFromEvent(event) {
    var detail = event && event.detail;
    if (!detail || detail.data?.didError) return;

    var variantId = detail.sourceId;
    var productId = detail.data?.productId;
    var quantity = Number(detail.data?.itemCount) || 1;
    var cfg = window.pathrohiMetaPixel || {};
    var value = 0;

    if (cfg.product && String(cfg.product.variantId) === String(variantId)) {
      value = moneyValue(cfg.product.price) * quantity;
    }

    track('AddToCart', {
      content_ids: variantId ? [String(variantId)] : productId ? [String(productId)] : [],
      content_type: 'product',
      value: value,
      currency: cfg.currency || 'INR',
      num_items: quantity,
    });
  }

  window.pathrohiTrackInitiateCheckout = function (options) {
    var cfg = window.pathrohiMetaPixel || {};
    var payload = {
      content_type: 'product',
      currency: cfg.currency || 'INR',
      num_items: options?.num_items || 1,
    };

    if (options?.value != null) payload.value = options.value;
    if (options?.content_ids?.length) payload.content_ids = options.content_ids;

    track('InitiateCheckout', payload);
  };

  function runWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function hookGoKwikInitCheckout() {
    if (window.__pathrohiGokwikHooked) return true;

    var sdk = window.gokwikSdk;
    if (!sdk || typeof sdk.initCheckout !== 'function') return false;

    var original = sdk.initCheckout.bind(sdk);
    sdk.initCheckout = function () {
      if (typeof window.pathrohiTrackInitiateCheckout === 'function') {
        window.pathrohiTrackInitiateCheckout({ num_items: 1 });
      }
      return original.apply(sdk, arguments);
    };

    window.__pathrohiGokwikHooked = true;
    return true;
  }

  function waitForGoKwikHook() {
    if (hookGoKwikInitCheckout()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (hookGoKwikInitCheckout() || attempts > 80) clearInterval(timer);
    }, 250);
  }

  runWhenReady(function () {
    trackViewContent();
    waitForGoKwikHook();
  });

  document.addEventListener('cart:update', trackAddToCartFromEvent);
})();
